export default __webpack_public_path__ + "static/media/main-logo.d08478e9.svg";